import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import ListResponse from 'model/ListResponse';
import { Settlement } from 'model/Settlements';
import React, { useEffect, useState } from 'react';

interface Data {
  [year: string]: {
    [coachName: string]: Settlement[];
  };
}
export default function useSettlementsUser(
  status: string,
  year?: number,
  month?: number,
) {
  const settlementsQuery = useQuery<ListResponse<Settlement>>(
    API_PATH.COACHES_SETTLEMENTS,
    {
      limit: 500,
      [status ? 'status' : '']: status,
      ...(year ? { year } : {}),
      ...(month ? { month } : {}),
    },
  );

  const targetYearMonth =
    year && month
      ? `${year}-${String(month).padStart(2, '0')}`
      : undefined;

  return {
    data:
      settlementsQuery.getQuery.data?.data?.items.reduce((acc: Data, now) => {
        if (targetYearMonth && now.base_year_month !== targetYearMonth)
          return acc;
        const data = {
          ...acc,
          [now.base_year_month]: {
            ...(acc[now.base_year_month] || {}),
            [now.coach_user.name]: [
              ...((acc[now.base_year_month] || {})[now.coach_user.name] || []),
              now,
            ],
          },
        };

        return data;
      }, {}) || {},
    isLoading: settlementsQuery.getQuery.isLoading,
  };
}
